// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_XuK","cls2":"FeedbackPopover-cls2_xME FeedbackPopover-cls1_XuK"};